export default __webpack_public_path__ + "static/media/640_portfolio02-es-mobile.ef3b378c.png";